module.exports = __webpack_public_path__ + "static/och-logo-a0f672c10755b79c9fbc012df8e43242.png";